import type { RowData } from "@tanstack/react-table";
import { CellText } from "./CellText";
import { toDateRangeText } from "./cellValues";
import { EmptyCellValue } from "./EmptyCellValue";
import { HighlightedText } from "./HighlightedText";
import type { DataGridCellProps } from "./types";
import styles from "./cellContent.module.scss";

/**
 * Date range column cell for a `DateOnlyRange`: "Jan 1 – Mar 31", the year
 * shown only when needed, "From Jan 1" or "Until Mar 31" for an open side,
 * in any column that renders it. Search matches the same text in
 * `col.dateRange` columns.
 */
export const DateRangeCell = <TData extends RowData>({
    context,
    meta,
}: Readonly<DataGridCellProps<TData>>) => {
    const text = toDateRangeText(context.getValue());
    if (text === null) {
        return <EmptyCellValue empty={meta.empty} />;
    }
    return (
        <CellText text={text} overflow={meta.overflow} tone={meta.tone}>
            <span className={styles.numeric}>
                <HighlightedText text={text} table={context.table} />
            </span>
        </CellText>
    );
};
